import { TraitRegistryCategory } from '../TraitRegistryCategory';
import { TraitTypeSelect } from '../traitTypes/TraitTypeSelect';
import { TraitsOrderedChoice } from '../../../questiontype/OrderedChoice/registry/TraitsOrderedChoice';
export class TraitRegistryQuestionType extends TraitRegistryCategory {
    label = 'QuestionType';
    constructor(parent) {
        super(parent);
        super.init();
    }
    c_oc = new TraitsOrderedChoice(this);
    questionTypeName = () => new TraitTypeSelect({
        default: 'MultipleChoice'
        /*label: 'Fragetyp',
      select: () => Object.values(QuestionTypeName).map(qt => [qt]) as any */
    });
}
